/* Rhea - collection grid: video tiles */
(function () {
  var MAIN = 'https://cdn.shopify.com/videos/c/vp/369e73e4e2054fd4a895ad51b96d8b65/369e73e4e2054fd4a895ad51b96d8b65.HD-720p-4.5Mbps-94849129.mp4';
  var CRAFT = 'https://cdn.shopify.com/videos/c/vp/0c2012351db7432aba1a867e743b78e6/0c2012351db7432aba1a867e743b78e6.HD-720p-4.5Mbps-43019257.mp4';

  function tile(src, key) {
    var d = document.createElement('div');
    d.className = 'rhea-vid';
    d.setAttribute('data-rhea-vid', key);
    var v = document.createElement('video');
    v.setAttribute('muted', '');
    v.setAttribute('autoplay', '');
    v.setAttribute('loop', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('preload', 'metadata');
    v.muted = true;
    v.defaultMuted = true;
    v.autoplay = true;
    v.loop = true;
    v.playsInline = true;
    v.src = src;
    d.appendChild(v);
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
    return d;
  }

  function insertAt(grid, node, index) {
    grid.insertBefore(node, grid.children[index] || null);
  }

  function place() {
    var grid = document.querySelector('[data-products-grid] .js-grid');
    if (!grid) return;
    if (grid.querySelector('.js-grid__full-row')) return;
    var cells = grid.querySelectorAll(':scope > *:not(.rhea-vid)').length;
    if (cells < 4) return;
    if (!grid.querySelector('[data-rhea-vid="main"]')) {
      insertAt(grid, tile(MAIN, 'main'), 1);
    }
    if (cells >= 14 && !grid.querySelector('[data-rhea-vid="craft"]')) {
      insertAt(grid, tile(CRAFT, 'craft'), 11);
    }
    var ref = grid.querySelector(':scope > *:not(.rhea-vid) .product-grid-item__images');
    if (ref) {
      var ratio = getComputedStyle(ref).getPropertyValue('--wh-ratio').trim();
      if (ratio) { grid.style.setProperty('--rhea-card-ratio', ratio); }
    }
    grid.querySelectorAll('.rhea-vid video').forEach(function (v) {
      if (v.paused) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    });
  }

  function watch() {
    place();
    var host = document.querySelector('[data-products-grid]');
    if (!host) return;
    new MutationObserver(function () { place(); }).observe(host, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', place);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
